var map = {
	"./ar.json": "Hlp3",
	"./en.json": "Ws+D",
	"./es.json": "3jmB",
	"./fr.json": "37Vy",
	"./website/en.json": "/9H5",
	"./zh.json": "kQDO"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y27P";